import { Component } from "react";

import AutoComplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Button from "@material-ui/core/Button";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import {
  simpleDateFormater,
  numberWithSpaces,
} from "../../../utilities/formaters";

class AccountingMatchingComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      machingValue: "",
    };
  }

  updateMachingValue = (machingText) => {
    let stripped = machingText.replace(/\s/g, "");
    this.setState({ ...this.state, machingValue: stripped });
    // sen the value up the component tree
    this.props.updateMachingValue(stripped);
  };

  render() {
    let item = this.props.item;
    let amount = item.Amount ? item.Amount.Amount : item._amount.Amount;

    return (
      <div>
        <ListItem disabled={true}>
          <ListItemText
            primary={
              <div>
                Ref code: <strong>{item.RefCode}</strong>
              </div>
            }
            secondary={
              <div>
                <span>
                  Amount: <strong>{numberWithSpaces(amount)}</strong>
                </span>
                {this.props.showDate ? (
                  <span>
                    <br />
                    <span>
                      Due Date:{" "}
                      <strong>{simpleDateFormater(item.DueDate)}</strong>
                    </span>
                  </span>
                ) : undefined}
              </div>
            }
          />
          <ListItemSecondaryAction>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: "30px" }}
              onClick={this.props.manualMatch.bind(
                this,
                item,
                this.state.machingValue,
              )}
            >
              Match
            </Button>
          </ListItemSecondaryAction>
        </ListItem>

        <AutoComplete
          filter={AutoComplete.caseInsensitiveFilter}
          value={this.state.machingValue}
          onChange={(event, newValue) => {
            this.updateMachingValue(newValue);
          }}
          options={this.props.providerIds}
          renderInput={(params) => (
            <TextField
              size="small"
              {...params}
              label="Provide payment id"
              variant="outlined"
              fullWidth
            />
          )}
        />
      </div>
    );
  }
}
export default AccountingMatchingComponent;
